import Card from 'food-benefit.module/common/domain/models/foodBenefitCard';

class delegationsFormatter {
  static assemble(data) {
    let delegationsArray = buildDelegations(data);
    return delegationsArray;
  }

}

function buildDelegations(data) {
  let delegations = [];
  data.forEach((rawDelegation) => {
    rawDelegation.employeeProfile.userId = rawDelegation.employeeProfile.employeeId;
    let delegation = {
      profile: rawDelegation.employeeProfile,
      cards: [],
    };

    for (let key in rawDelegation.foodBenefitPeriods) {
      let obj = rawDelegation.foodBenefitPeriods[key];
      obj.id = delegation.profile.employeeId;
      delegation.cards.push(new Card(obj));
    }

    delegations.push(delegation);
  });

  return delegations;
}

export default delegationsFormatter;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/common/domain/formatters/delegationsFormatter.js